import RedeemQr from './RedeemQr';

export default RedeemQr;